import BritishBroadcastingCorporationWEBP from '../src/assets/BrandEndorsementsSectionAssets/bbc.webp'
import EveningStandardPNG from '../src/assets/BrandEndorsementsSectionAssets/eveningstandard.png'
import EveningStandardWEBP from '../src/assets/BrandEndorsementsSectionAssets/eveningstandard.webp'
import IndependentPNG from '../src/assets/BrandEndorsementsSectionAssets/independent.png'
import IndependentWEBP from '../src/assets/BrandEndorsementsSectionAssets/independent.webp'
import MarieClairePNG from '../src/assets/BrandEndorsementsSectionAssets/marieclaire.png'
import MarieClaireWEBP from '../src/assets/BrandEndorsementsSectionAssets/marieclaire.webp'
import TheTelegraphPNG from '../src/assets/BrandEndorsementsSectionAssets/thetelegraph.png'
import TheTelegraphWEBP from '../src/assets/BrandEndorsementsSectionAssets/thetelegraph.webp'
import BritishBroadcastingCorporationPNG from './assets/BrandEndorsementsSectionAssets/bbc.png'

export const CUSTOMER_REVIEWS = {
  headerTabletAndDesktop: 'OVER 30,000 5-STAR REVIEWS',
  headerMobileLine1: 'OVER 30,000 ',
  headerMobileLine2: '5-STAR REVIEWS',
  review: [
    {
      quote:
        '“It’s just so convenient to have a quick meal for the evenings when we get home late from work.”',
      reviewer: 'Holly',
    },
    {
      quote: '“The quick and easy recipes are a lifesaver.”',
      reviewer: 'Alex',
    },
    {
      quote:
        '“Fun to make with the kids and things taste better when you’ve cooked them as a family!”',
      reviewer: 'Ed',
    },
    {
      quote:
        '“I love knowing that I can finish work, go to the gym and just know what’s for dinner.”',
      reviewer: 'Naomi',
    },
    {
      quote: '“Something I’m really grateful for with Gousto - teaching me about portion sizing.”',
      reviewer: 'Katie',
    },
  ],
}

export const HOW_OUR_RECIPE_BOXES_WORK = {
  header: 'How our recipe boxes work',
  benefits: [
    {
      title: 'Create your box',
      description: 'Choose your box size (1 to 5 people) and your preferred delivery day.',
    },
    {
      title: 'Choose your recipes',
      description: 'Pick from 175+ recipes every week (there’s something for everyone).',
    },
    {
      title: 'Cook up seriously tasty meals',
      description: 'Get your ingredients delivered and ditch the supermarket chaos.',
    },
    {
      title: 'Flex your subscription',
      description: 'Skip or cancel whenever you like or change how often you get your boxes.',
    },
  ],
}

export const CWC_HOW_IT_WORKS = {
  header: "LET'S GET COOKING",
  benefits: [
    {
      title: 'Build your box',
      description: 'Choose your box size (1 to 5 people) and your delivery day.',
    },
    {
      title: 'Pick your recipes',
      description: 'Discover global cuisines and cater to every dietary need.',
    },
    {
      title: 'Let us do the hard work',
      description: 'Get pre-measured ingredients delivered to your door.',
    },
    {
      title: 'Make changes whenever',
      description: 'Edit, skip or cancel your orders easily online at any time.',
    },
  ],
  linkButtonLabel: 'How Gousto recipe boxes work',
  linkButtonUrl: 'https://www.gousto.co.uk/food-box/how-it-works',
}

export const BRAND_ENDORSEMENTS = {
  header: 'Tested and loved by',
  images: {
    britishBroadcastingCorporation: {
      png: BritishBroadcastingCorporationPNG,
      webp: BritishBroadcastingCorporationWEBP,
    },
    eveningStandard: {
      png: EveningStandardPNG,
      webp: EveningStandardWEBP,
    },
    independent: {
      png: IndependentPNG,
      webp: IndependentWEBP,
    },
    marieClaire: {
      png: MarieClairePNG,
      webp: MarieClaireWEBP,
    },
    theTelegraph: {
      png: TheTelegraphPNG,
      webp: TheTelegraphWEBP,
    },
  },
}

export const VALUE_YOU_CAN_TASTE = {
  desktopVideoURL: 'https://production-media.gousto.co.uk/videos/hp-video-desktop.mp4',
  mobileVideoURL: 'https://production-media.gousto.co.uk/videos/hp-video-mobile.mp4',
  header: 'Cook Smarter, Not Harder',
}

export const OUR_SUPPLIERS_COPY = {
  ourSuppliersURL: 'https://www.gousto.co.uk/blog/suppliers',
  sustainabilityURL: 'https://www.gousto.co.uk/blog/sustainability',
  heading: 'Great food starts with great ingredients',
  ctaLabel: 'Discover our suppliers',
}

/**
 * A run of card body copy. `strong` segments render in the red emphasis style;
 * plain segments render as regular body text. `breakBefore` inserts a line break before the segment
 * on mobile only (no break from tablet up) — used to control where the copy wraps on narrow widths.
 */
export type WhatsNewBodySegment = { text: string; strong?: boolean; breakBefore?: boolean }

export type WhatsNewCard = {
  title: string
  body: WhatsNewBodySegment[]
  /** Alt text for the card's background image (the image asset itself is wired in the component). */
  imageAlt: string
}

/**
 * Static copy for the CWC homepage "What's New" section. Copy is verified
 * against Figma (node 74-476). Card background images are handled in the
 * component (aligned to this array by index), so this config stays asset-free.
 * The primary CTA label is the section's designed conversion copy and lives here,
 * not the caller — the assembly only supplies the sign-up destination and handler.
 */
export const CWC_WHATS_NEW: {
  heading: string
  cta: string
  cards: WhatsNewCard[]
  pills: { nextDayDelivery: string; adjustPortions: string }
} = {
  heading: 'What’s new',
  cta: 'Get started with 50% off',
  cards: [
    {
      title: 'Super tasty, super fast',
      body: [
        { text: 'We’ve doubled our range of ' },
        { text: '10 minute meals', strong: true },
        { text: ' to over ' },
        { text: '40\u00A0every\u00A0week', strong: true },
        { text: '.' },
      ],
      imageAlt:
        "A bowl of veggie tortiglioni with pesto and fresh basil, part of Gousto's 10 minute meals",
    },
    {
      title: 'Heat & Eat',
      body: [
        { text: 'All the flavour of Gousto, ' },
        { text: 'none of the prep', strong: true },
        { text: ' and no nasties.' },
      ],
      imageAlt:
        'Chicken tikka masala with saffron rice in a Gousto heat-and-eat tray, served on a blue plate',
    },
    {
      title: 'Built for real life',
      body: [
        { text: 'Easy to ' },
        { text: 'adjust portions', strong: true },
        { text: ', skip a week or add an ' },
        { text: 'extra box with ', strong: true },
        // On mobile "next-day delivery" drops to its own line (per design); inline from tablet up.
        { text: 'next-day delivery', strong: true, breakBefore: true },
        { text: '.' },
      ],
      imageAlt:
        'Infographic showing you can adjust your portions or get next day delivery with a gousto box in the background',
    },
  ],
  pills: {
    nextDayDelivery: 'Next day delivery',
    adjustPortions: 'Adjust portions',
  },
}
